/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const GET_REQUEST_MAILING_MANUFACTURER_DETAILS = "GET_REQUEST_MAILING_MANUFACTURER_DETAILS";
export const GET_ALL_REBATE_PROGRAMS = "GET_ALL_REBATE_PROGRAMS";
export const GET_ALL_ADDRESS_TYPE_CODE = "GET_ALL_ADDRESS_TYPE_CODE";
export const SEARCH_MAILING_REQUEST = "SEARCH_MAILING_REQUEST";
export const HANDLE_HEADER_ERROR_MSG = "HANDLE_HEADER_ERROR_MSG";
export const HANDLE_FIELD_LEVE_ERROR_MSG = "HANDLE_FIELD_LEVE_ERROR_MSG";
export const GET_COUNT_MGF_LABEL_REQUEST_LABEL = "GET_COUNT_MGF_LABEL_REQUEST_LABEL";
export const GET_COUNT_FILTERED_MGF_LABEL_REQUEST_LABEL = "GET_COUNT_FILTERED_MGF_LABEL_REQUEST_LABEL";
export const GET_MGF_LABEL_REQUEST_LABEL = "GET_MGF_LABEL_REQUEST_LABEL";
export const GET_FILTERED_MGF_LABEL_REQUEST_LABEL = "GET_FILTERED_MGF_LABEL_REQUEST_LABEL";
